import { styled } from 'stitches.config'
import { Stack } from 'components/Stack'
import { Text } from 'components/Text'
import { BorderWave } from 'components/BorderWave'

export const RecipeFooterRoot = styled('div', {
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'flex-end',
  position: 'relative',
  overflow: 'hidden',
  background: 'transparent',

  variants: {
    background: {
      'tertiary-200': {
        background: '$tertiary-200',
        '@bp3': {
          background: 'transparent',
        },
      },
    },
  },

  defaultVariants: {
    background: 'transparent',
  },
})

export const RecipeFooterButton = styled('button', {
  color: '$primary-500',
  width: '200px',
  height: '36px',
  backgroundColor: '$accent-white',
  fontWeight: '$semiBold',
  borderRadius: '24px',
  borderStyle: 'none',
  '&:hover': {
    color: '$primary-400',
  },
})

export const ContentWrapper = styled(Stack, {
  position: 'relative',
  width: '100%',
  margin: 'auto',
  display: 'flex',
  flexDirection: 'column',
  background: '$primary-500',
  paddingTop: '20px',
  paddingBottom: '50px',
  gap: '0',
  '@bp2': {
    gap: '$2',
  },
})

export const RecipeFooterText = styled(Text, {
  width: '100%',
  maxWidth: '360px',
  '@bp2': {
    width: '100%',
    maxWidth: 'none',
  },
})

export const BorderWrapper = styled(BorderWave, {
  top: '1px',
})
